import { createContext } from 'react';
export const StatusDataContext = createContext({
    statusDataLoading: true,
    codesLoading: false,
    definitionsLoading: false,
    glossaryLoading: false,
    productAttributeCodes: [],
    statusDefinitionList: [],
    glossary: [],
    legacyPref: false,
    setLegacyPref: (val) => { },
});
export default StatusDataContext;
